import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type QuoteProductDataType = Partial<ApiSchema["QuoteProduct"]["type"] & EDocumentProductDataType>;
export const QuoteProductApi = new GenericModelApi<"QuoteProduct", QuoteProductDataType>("QuoteProduct", "codigo");